var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditPencil = function SvgEditPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.64v2.027A.33.33 0 0 0 .333 12H2.36a.31.31 0 0 0 .233-.1l7.279-7.272-2.5-2.5L.1 9.4a.33.33 0 0 0-.1.24m11.805-6.945c.26-.26.26-.68 0-.94l-1.56-1.56a.664.664 0 0 0-.94 0l-1.22 1.22 2.5 2.5z"
  })));
};
export default SvgEditPencil;